module.exports = __webpack_public_path__ + "assets/rm-long-logo-white.86d2cd5e.svg";